import { jsx } from 'react/jsx-runtime';
import classNames from 'classnames';
import { CreditCard, Invoice, SavingBankCash, Delivery } from '@zooplus/icons';
import Svgs from '../../../components/svgs/index.js';
import styles from './PaymentLogo.module.scss.js';

const iconLogos = ['K', 'R', 'VK', 'CD'];
const IMAGE_LOGOS = {
    AP: 'appleLogo',
    BS: 'sepaLogo',
    PP: 'paypalLogo',
    ID: 'idealLogo',
    DP: 'dotpayLogo',
    BM: 'bancontactLogo',
    BC: 'bancontactLogo',
    MB: 'multibancoLogo',
    OP: 'opLogo',
    KO: 'klarnaLogo',
    KL: 'klarnaLogo',
    PT: 'paytrailLogo',
    TY: 'trustlyLogo',
    TW: 'twintLogo',
};
const ICON_LOGOS = {
    K: jsx(CreditCard, {}),
    R: jsx(Invoice, {}),
    VK: jsx(SavingBankCash, {}),
    CD: jsx(Delivery, {}),
};
const PaymentLogo = ({ className, method, url }) => {
    const alt = method || '';
    return (method &&
        (iconLogos.includes(method) ? (jsx("i", { className: classNames(styles.paymentIcon, className), children: ICON_LOGOS[method] })) : url ? (jsx("img", { src: url, className: classNames(styles.paymentLogo, className), alt: alt })) : (jsx(Svgs, { type: IMAGE_LOGOS[method], className: classNames(styles.paymentLogo, className) }))));
};

export { PaymentLogo as default };
//# sourceMappingURL=PaymentLogo.js.map
